import { configureCrispLocked } from "../../utils/crispConfig";

import { useEffect } from "react";

const CrispWeb = () => {
  useEffect(() => {
    configureCrispLocked({
      autoload: true,
      lockMaximized: true,
      lockFullview: true
    });
  }, []);

  return <></>;
};

export default CrispWeb;
